import React, { useState, useEffect } from 'react'
import ReactApexChart from 'react-apexcharts'

const PLSSpeedometer = (props) => {
    
    const [options, setOptions] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    
    useEffect(() => {
        
        let opts = {
            colors: ['#ffda44'],

            chart: {
                height: 350,
                type: 'radialBar',
                offsetY: -10
            },

            plotOptions: {
                radialBar: {
                    startAngle: -135,
                    endAngle: 135,
                    dataLabels: {
                        name: {
                            fontSize: '16px',
                            color: '#000000',
                            offsetY: 120
                        },
                        value: {
                            offsetY: 76,
                            fontSize: '22px',
                            color: undefined,
                            formatter: function (val) {
                                return val + "%";
                            }
                        }
                    }
                }
            },

            fill: {
                type: 'gradient',
                gradient: {
                    shade: 'dark',
                    shadeIntensity: 0.15,
                    inverseColors: false,
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 50, 65, 91]
                },
            },

            stroke: {
                dashArray: 4
            },

            labels: [props.label]
    };

        setOptions(opts);
        setIsLoaded(true);
    }, [props.label]);

    if (!isLoaded) {
        return (<div>KEK</div>);
    }

    return (
        <ReactApexChart options={options} series={[Math.round(props.value * 100)]} type="radialBar" height={350} />
    );
}

export default PLSSpeedometer;